// extracted by mini-css-extract-plugin
export default {"root":"IconCopy_root__2m0jW"};